import { SampleStatus } from '@modules/study-insights/types/samples.types';

// Filter constants for received samples data
export const RECEIVED_SAMPLES_STATUS_FILTER = [
  SampleStatus.RECEIVED,
  SampleStatus.SEQUENCING_COMPLETE,
  SampleStatus.IN_SEQUENCING,
  SampleStatus.RESULTS_DELIVERED,
];

// Filter constants for sequenced samples data
export const SEQUENCED_SAMPLES_STATUS_FILTER = [
  SampleStatus.RECOLLECT,
  SampleStatus.RESULTS_DELIVERED,
  SampleStatus.SEQUENCING_COMPLETE,
];

export const AWAITING_SAMPLES_STATUS_FILTER = [SampleStatus.AWAITING];
export const RESULTS_DELIVERED_STATUS_FILTER = [SampleStatus.RESULTS_DELIVERED];
